import { createSlice } from "@reduxjs/toolkit";
import { notification } from "antd";
import {
  fetchCmsFiles,
  addCmsFile,
  updateCmsFileAction,
  removeCmsFile,
} from "./actions";

const initialState = {
  cmsFiles: [],
  cmsFilesLoading: false,
  cmsFilesError: null,

  createCmsFile: {},
  createCmsFileLoading: false,
  createCmsFileError: null,

  updateCmsFile: {},
  updateCmsFileLoading: false,
  updateCmsFileError: null,

  deleteCmsFile: {},
  deleteCmsFileLoading: false,
  deleteCmsFileError: null,
};

const cmsFilesSlice = createSlice({
  name: "cmsFiles",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      // Fetch CMS files cases
      .addCase(fetchCmsFiles.pending, (state) => {
        state.cmsFilesLoading = true;
        state.cmsFilesError = null;
      })
      .addCase(fetchCmsFiles.fulfilled, (state, action) => {
        state.cmsFilesLoading = false;
        state.cmsFiles = action.payload;
        if (action?.payload?.meta?.success !== true) {
          notification.error({
            message: "Error",
            description: action?.payload?.meta?.message || "Failed to fetch CMS files",
            duration: 2,
          });
        }
      })
      .addCase(fetchCmsFiles.rejected, (state, action) => {
        state.cmsFilesLoading = false;
        state.cmsFilesError = action.payload;
        notification.error({
          message: "Error",
          description: action?.payload?.meta?.message || "Failed to fetch CMS files",
          duration: 2,
        });
      })

      // Create CMS file cases
      .addCase(addCmsFile.pending, (state) => {
        state.createCmsFileLoading = true;
        state.createCmsFileError = null;
      })
      .addCase(addCmsFile.fulfilled, (state, action) => {
        state.createCmsFile = action.payload;
        state.createCmsFileLoading = false;
        if (action?.payload?.meta?.success === true) {
          // // Add the new CMS file to the list if we're on the first page
          // if (state.cmsFiles?.data?.pagination?.page === 1) {
          //   state.cmsFiles.data.files = [
          //     action.payload?.data,
          //     ...state?.cmsFiles?.data?.files,
          //   ];
          // }
          // // Increment total count
          // if (state.cmsFiles?.data?.pagination) {
          //   state.cmsFiles.data.pagination.total += 1;
          // }
          notification.success({
            message: "Success",
            description: action?.payload?.meta?.message || "CMS file created successfully",
            duration: 2,
          });
        } else {
          notification.error({
            message: "Error",
            description: action?.payload?.meta?.message || "Failed to create CMS file",
            duration: 2,
          });
        }
      })
      .addCase(addCmsFile.rejected, (state, action) => {
        state.createCmsFileLoading = false;
        state.createCmsFileError = action.payload;
        notification.error({
          message: "Error",
          description: action?.payload?.meta?.message || "Failed to create CMS file",
          duration: 2,
        });
      })

      // Update CMS file cases
      .addCase(updateCmsFileAction.pending, (state) => {
        state.updateCmsFileLoading = true;
        state.updateCmsFileError = null;
      })
      .addCase(updateCmsFileAction.fulfilled, (state, action) => {
        state.updateCmsFile = action.payload;
        state.updateCmsFileLoading = false;
        if (state.cmsFiles?.data?.files) {
          state.cmsFiles.data.files = state.cmsFiles.data.files.map(
            (cmsFile) => cmsFile.id === action.payload.data.id ? action.payload.data : cmsFile
          );
        }
        if (action?.payload?.meta?.success === true) {
          notification.success({
            message: "Success",
            description: action?.payload?.meta?.message || "CMS file updated successfully",
            duration: 2,
          });
        } else {
          notification.error({
            message: "Error",
            description: action?.payload?.meta?.message || "Failed to update CMS file",
            duration: 2,
          });
        }
      })
      .addCase(updateCmsFileAction.rejected, (state, action) => {
        state.updateCmsFileLoading = false;
        state.updateCmsFileError = action.payload;
        notification.error({
          message: "Error",
          description: action?.payload?.meta?.message || "Failed to update CMS file",
          duration: 2,
        });
      })

      // Delete CMS file cases
      .addCase(removeCmsFile.pending, (state) => {
        state.deleteCmsFileLoading = true;
        state.deleteCmsFileError = null;
      })
      .addCase(removeCmsFile.fulfilled, (state, action) => {
        state.deleteCmsFile = action.payload;
        state.deleteCmsFileLoading = false;
        if (state.cmsFiles?.data?.files) {
          state.cmsFiles.data.files = state.cmsFiles.data.files.filter(
            (cmsFile) => cmsFile.id !== action.payload.id
          );
          if (state.cmsFiles?.data?.pagination) {
            state.cmsFiles.data.pagination.total -= 1;
          }
        }
        if (action?.payload?.meta?.success === true) {
          notification.success({
            message: "Success",
            description: action?.payload?.meta?.message || "CMS file deleted successfully",
            duration: 2,
          });
        } else {
          notification.error({
            message: "Error",
            description: action?.payload?.meta?.message || "Failed to delete CMS file",
            duration: 2,
          });
        }
      })
      .addCase(removeCmsFile.rejected, (state, action) => {
        state.deleteCmsFileLoading = false;
        state.deleteCmsFileError = action.payload;
        notification.error({
          message: "Error",
          description: action?.payload?.meta?.message || "Failed to delete CMS file",
          duration: 2,
        });
      });
  },
});

export default cmsFilesSlice.reducer;